import { render, staticRenderFns } from "./diagnosisOrder.vue?vue&type=template&id=01097d21&scoped=true"
import script from "./diagnosisOrder.vue?vue&type=script&lang=js"
export * from "./diagnosisOrder.vue?vue&type=script&lang=js"
import style0 from "./diagnosisOrder.vue?vue&type=style&index=0&id=01097d21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01097d21",
  null
  
)

export default component.exports